import { Theme as StyledTheme } from 'styled-system'

import { settings as typography, FontThemes } from './typography'
import { settings as space, SpaceTheme } from './spacing'
import { settings as colors, ColorTheme } from './colors'
import { settings as breakpoints, BreakpoinsTheme } from './breakpoints'
import { settings as borders, BorderTheme } from './borders'
import { settings as alignments, AlignmentTheme } from './alignments'

export type StyledProps = {
  as?: React.ElementType | keyof JSX.IntrinsicElements
}

export type Theme = StyledTheme &
  FontThemes &
  ColorTheme &
  SpaceTheme &
  BorderTheme &
  BreakpoinsTheme &
  AlignmentTheme

export const defaultTheme: Theme = {
  ...colors,
  ...breakpoints,
  ...space,
  ...typography,
  ...borders,
  ...alignments,
}
